import { __awaiter, __generator } from "tslib";
import * as React from 'react';
import DropDownMenu from '../client/src/modules/chat/components/DropDownMenu/DropDownMenu';
import ModalComp from '../client/src/modules/chat/components/Modal/Modal';
import { domainAction } from '../client/src/modules/domain/domain-redux';
import { BytesizeIcon } from '../client/src/modules/_core/components/BytesizeIcon';
import { api } from '../client/src/modules/_core/utils/api-helpers';
import { getSessionThreadId } from '../client/src/modules/_core/utils/app-storage';
import StaffinoWidget from './sazka/components/StaffinoWidget';
import { headerOnCloseHandler } from './sazka/externals-fns/header-close-handler';
var DropdownWithModal = function (props) {
    var cmp = props.cmp, openStaffino = props.openStaffino, content = props.content, handleCancel = props.handleCancel;
    var GDPRUrl = 'https://www.sazkahry.sk/ochrana-osobnych-udajov';
    var _a = React.useState(false), isModalOpen = _a[0], setIsModalOpen = _a[1];
    var _b = React.useState(), modalContent = _b[0], setModalContent = _b[1];
    var _c = React.useState(false), isSoundEnabled = _c[0], setIsSoundEnabled = _c[1];
    React.useEffect(function () {
        // external function is openining staffino
        if (openStaffino !== isModalOpen) {
            setIsModalOpen(openStaffino);
            setModalContent('staffino');
        }
    }, [openStaffino]);
    React.useEffect(function () {
        var useMsgSound = window.localStorage.getItem('useMsgSound');
        var isSoundEnabled = useMsgSound === 'true';
        setIsSoundEnabled(isSoundEnabled);
        domainAction.setUseMsgSound(isSoundEnabled);
    }, []);
    var getModalContent = function () {
        var content;
        switch (modalContent) {
            case 'staffino':
                content = (React.createElement(StaffinoWidget, { handleSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
                        var threadId;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    threadId = getSessionThreadId();
                                    return [4 /*yield*/, api().sendStaffino(threadId, values)];
                                case 1:
                                    _a.sent();
                                    headerOnCloseHandler(cmp, function () { }, true);
                                    handleCancel();
                                    return [2 /*return*/];
                            }
                        });
                    }); }, handleCancel: function () {
                        headerOnCloseHandler(cmp, function () { }, true);
                        handleCancel();
                    } }));
                break;
            default:
                break;
        }
        return content;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DropDownMenu, { items: [
                {
                    id: 'sound',
                    onClick: function () {
                        setIsSoundEnabled(!isSoundEnabled);
                        window.localStorage.setItem('useMsgSound', String(!isSoundEnabled));
                        cmp.props.dispatch(domainAction.setUseMsgSound(!isSoundEnabled));
                    },
                    content: "".concat(isSoundEnabled ? 'Vypnout' : 'Zapnúť', " zvuk"),
                },
                {
                    id: 'GDPR',
                    onClick: function () {
                        window.open(GDPRUrl, '_blank');
                    },
                    content: (React.createElement(React.Fragment, null,
                        React.createElement("a", { target: "_blank", href: GDPRUrl }, "GDPR"),
                        React.createElement(BytesizeIcon, { name: "arrow-right", size: "smallest", thickness: "medium" }))),
                },
            ], size: "sm" },
            React.createElement("span", { className: "menu-icon" })),
        React.createElement(ModalComp, { isModalOpen: isModalOpen, content: getModalContent(), handleClose: function () { return setIsModalOpen(handleCancel()); }, hideFooter: true })));
};
export default DropdownWithModal;
